// Version que se muestra en la entrada y al pie del menu, para saber que
// build esta corriendo en cada lugar (produccion, local, cada cliente).
// Se cambia aca y en package.json al sacar una version nueva.
export const VERSION = '1.0.2';
